module.exports = ".modal-body {\n  padding: 0px; }\n\n.alert {\n  margin: 0px; }\n\n.modal-title {\n  float: left; }\n\n.close {\n  float: right; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modal-edit/error-handler/error-handler.component.scss
// module id = ./src/app/modal-edit/error-handler/error-handler.component.scss
// module chunks = main